import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import {
  faAngleRight,
  faCog,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ShadowerLink from '../../../../components/ShadowerLink';
import Link from '../../../../components/Link';

import {
  Col,
  Grid,
  Row,
} from '../../../../incubation/components/ResponsiveGridLayout';

import PageLayout from '../../../../components/PageLayout';

import s from './TeamPage.scss';

function TeamPage() {
  return (
    <PageLayout className={s.page}>
      <section className={s.team}>
        <Grid>
          <Row>
            <Col>
              <h2 className="globalSectionHeading text-align-center">
                The Team Behind Shadower
              </h2>
              <div className={s.teamMembers}>
                <div className={s.member}>
                  <img
                    alt="Jason Pacini"
                    className={s.memberPhoto}
                    src="/assets/images/about/team/jason-poster.png"
                  />
                  <div className={s.memberText}>
                    <h3 className="globalCardHeading">Jason Pacini</h3>
                    <p className={s.role}>Founder</p>
                    <p>
                      Jason launched Shadower to create a single platform that
                      reaches beyond the limits of traditional education,
                      allowing amateurs from any industry to more efficiently
                      and affordably step in to the professional realm. As an
                      avid music producer, he was inspired to create the
                      platform to help amateur artists and others grow
                      professionally.
                    </p>
                  </div>
                </div>

                <div className={s.member}>
                  <img
                    alt="Jonathan Emig"
                    className={s.memberPhoto}
                    src="/assets/images/about/team/jonathan-poster.png"
                  />
                  <div className={s.memberText}>
                    <h3 className="globalCardHeading">Jonathan Emig</h3>
                    <p className={s.role}>Lead Developer</p>
                    <p>
                      Jonathan is the lead developer at Shadower, and the owner
                      of <a href="https://fluxtech.app">Flux Tech</a>. Jason
                      came to Jonathan with the Shadower concept and he knew
                      that he wanted to be a part of it.
                    </p>
                  </div>
                </div>

                <div className={s.member}>
                  <img
                    alt="Dan Hurlburt"
                    className={s.memberPhoto}
                    src="/assets/images/about/team/dan-poster.png"
                  />
                  <div className={s.memberText}>
                    <h3 className="globalCardHeading">Dan Hurlburt</h3>
                    <p className={s.role}>Senior Developer</p>
                    <p>
                      Dan has worked as a full-stack developer for over 14
                      years. He's been absolutely invaluable to the Shadower
                      project. This project would not have been possible without
                      his knowhow.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </section>

      <section className={s.learnMore}>
        <Grid>
          <Row>
            <Col>
              <h2 className="globalSectionHeading text-align-center">
                {' '}
                Learn more about Shadower
              </h2>

              <div className={s.options}>
                <div className={s.option}>
                  <FontAwesomeIcon className={s.optionIcon} icon={faCog} />

                  <Link className={s.links} to="/about">
                    How it works &nbsp;
                    <FontAwesomeIcon icon={faAngleRight} />
                  </Link>
                  <p>Find out what Shadower is all about.</p>
                </div>

                <div className={s.option}>
                  <FontAwesomeIcon className={s.optionIcon} icon={faSearch} />

                  <Link className={s.links} to="/shadowings/areas-of-expertise">
                    Find an expert &nbsp;
                    <FontAwesomeIcon icon={faAngleRight} />
                  </Link>
                  <p>
                    Get started shadowing and take your skillset to the next
                    level.
                  </p>
                </div>

                <div className={s.option}>
                  <FontAwesomeIcon
                    className={s.optionIcon}
                    icon={faUserCircle}
                  />
                  <Link className={s.links} to="/handbook">
                    Let People Shadow You &nbsp;
                    <FontAwesomeIcon icon={faAngleRight} />
                  </Link>
                  <p>Share your passions and earn some income along the way.</p>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </section>

      <section className={s.ourMissionSection}>
        <Grid>
          <Row>
            <Col>
              <div className={s.halfLayout}>
                <div className={s.missionStatement}>
                  <h2
                    className={cx('globalTextLeft', 'globalSecondaryHeading')}
                  >
                    Our Mission
                  </h2>
                  <p className={s.missionText}>
                    Our mission is to reimagine how education works in an age
                    when experience and connections matter most. We aim to make
                    education accessible, effective and affordable.
                  </p>
                </div>
                <ShadowerLink to="/demographics">
                  How Shadower can help you
                </ShadowerLink>
              </div>
            </Col>
          </Row>
        </Grid>
      </section>
    </PageLayout>
  );
}

export default withStyles(s)(TeamPage);
